<script lang="ts">
	import { goto } from '$app/navigation';
	import SearchMenu from '$lib/components/CollectionsNav/Search/SearchMenu.svelte';
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';

	export let hubName: string;

	export let value: string | null = null;

	let isSearchOpen = false;

	const keydownHandler = async (e: KeyboardEvent) => {
		if (e.key == 'Enter' && value) {
			await goto(`/${$page.params.hubPrefix}/search?q=${value}&app=svelte`);
			isSearchOpen = false;
		}

		//TODO: Should change focus to dropdown on arrow down
	};
</script>

<!-- svelte-ignore a11y-autofocus -->
<input
	on:keydown={keydownHandler}
	placeholder={$_('hubs.search.placeholder', { values: { hub: hubName } })}
	bind:value
	autofocus />
<SearchMenu bind:value bind:isOpen={isSearchOpen} />

<style>
	input {
		z-index: var(--z-index-Hub-collections);
		block-size: 100%;
		inline-size: 100%;
		border: none;
		background-color: transparent;
		color: var(--collectionsFontColor);
		font-size: var(--fontSizeNormal);
	}

	input:focus {
		outline: none;
	}
</style>
